export default "__VITE_ASSET__Ce0xF3dG__"